exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".embedded-video-wrapper--div {\n  position: relative;\n  height: 0px;\n  padding: 0px 0px 56.25%;\n  /* 16:9 */\n}\n.embedded-video-wrapper--div iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100% !important;\n  height: 100% !important;\n}\n", ""]);

